import React from "react";
import { ProgramOverviewPage } from "./View";
export var programsRoute = {
    match: function (type) { return type === "ProgramOverview"; },
    page: function () { return React.createElement(ProgramOverviewPage, null); },
};
